export const Rh = {
  // Letra A:
  ACOES: 'Ações',
  ANEXO: 'Anexo',

  // Letra B:
  BAIXAR_ANEXO: 'Baixar anexo',
  // Letra C:
  CADASTRAR_FUNCIONARIO: 'Cadastrar funcionário',
  CADASTRAR_MATRICULA: 'Cadastrar matrícula',
  CADASTRAR_PESSOA: 'Cadastrar pessoa',
  CADASTRAR_PROFESSOR: 'Cadastrar professor',
  CARGO: 'Cargo',
  CONFIGURACOES: 'Configurações',
  CPF: 'CPF',

  // Letra D:
  DEPARTAMENTO: 'Departamento',
  DOCUMENTOS: 'Documentos',
  DATA_PROTOCOLO: 'Data de criação',
  DATA_NASCIMENTO: 'Data de nascimento',
  DATA_ADMISSAO: 'Data de admissão',
  DATA_DEMISSAO: 'Data de demissão',
  // Letra E:
  EMAIL: 'E-mail',
  ENDERECO: 'Endereço',
  // Letra F:
  FUNCIONARIOS: 'Funcionários',
  FORMULARIO_PROTOCOLO: 'Formulário protocolo',
  FUNCIONARIO_DESCRICAO:
    'Nessa tela você pode gerenciar os funcionário, criar, editar e trazer a lista por filtro.',

  // Letra G:
  // Letra H:
  // Letra I:
  INFORMACOES_PESSOAIS: 'Informações pessoais',
  INFORMACOES_BANCARIAS: 'Informações bancárias',
  IMPRIMIR_RELATORIO_FUNCIONARIOS: 'Imprimir Relatório de Funcionários',
  IMPRIMIR_RELATORIO_FUNCIONARIOS_DESCRICAO:
    'Nessa tela é possível gerar o relatório de funcionários, selecione as opções no filtro e clique em gerar relatório.',

  // Letra J:
  // Letra K:
  // Letra L:
  // Letra M:
  MATRICULA: 'Matrícula',
  // Letra N:
  NOME: 'Nome',
  NENHUM_REGISTRO: 'Nenhum registro',
  // Letra O:
  // Letra P:
  PESSOAS: 'Pessoas',
  PESSOAS_DESCRICAO:
    'Nessa tela você pode buscar, criar, editar e cadastrar pessoas. Para isso utilize o botão do filtro, o botão <strong> Cadastrar </strong> ou o botão de <strong> Ações </strong> nas linhas da tabela.',
  PROFESSORES: 'Professores',
  PROTOCOLOS: 'Alteração Cadastral',
  PROTOCOLOS_DESCRICAO:
    'Nessa tela você pode visualizar os protocolos de alteração cadastral abertos e responde-los.',

  // Letra Q:
  // Letra R:
  RECURSOS_HUMANOS: 'Recursos humanos',
  RESPOSTA: 'Resposta',
  RESPONDER_PROTOCOLO: 'Responder',

  // Letra S:
  SALVAR_CADASTRAR_MATRICULA: 'Salvar e cadastrar matrícula',
  SITUACAO: 'Situação',
  SOLICITANTE: 'Solicitante',
  STATUS: 'Status',

  // Letra T:
  TIPO: 'Tipo',
  TITULO_PROTOCOLO: 'Título',
  TIPO_FUNCIONARIO: 'Tipo de funcionário',
  TITULACOES: 'Titulações',
  TELEFONE: 'Telefone',
  // Letra U:
  // Letra V:
  VISUALIZAR_MATRICULA: 'Visualizar matrícula',

  // Letra X:
  // Letra Y:
  // Letra Z:
};
